<template>
  <div v-if="items && items.length > 0" class="table-responsive">
    <table class="table table-hover">
      <template v-if="type === 'single'">
        <thead>
        <tr>
          <th>{{'store' | translate}}</th>
          <th class="is-clickable" @click="() => {sort === 'desc' ? sort = 'asc' : sort = 'desc'; $emit('sort', sort)}"><i :class="[sort === 'desc' ? 'fa fa-sort-desc' : 'fa fa-sort-asc', 'mr-5']"></i>{{'invoice_from_to' | translate}}</th>
          <th>{{'download' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items">
          <td class="is-clickable" @click="$emit('store', item.store_id)">{{getStore(item.store_id)}}</td>
          <td>{{item.date_range_from}} - {{item.date_range_to}}</td>
          <td><a class="btn btn-success btn-sm" :href="item.summary_path" target="_blank"><i class="fa fa-cloud-download mr-5"></i>Download CSV</a></td>
        </tr>
        </tbody>
      </template>
      <template v-else>
        <thead>
        <tr>
          <th>{{'record' | translate}}</th>
          <th class="is-clickable" @click="() => {sort === 'desc' ? sort = 'asc' : sort = 'desc'; $emit('sort', sort)}"><i :class="[sort === 'desc' ? 'fa fa-sort-desc' : 'fa fa-sort-asc', 'mr-5']"></i>{{'invoice_from_to' | translate}}</th>
          <th>{{'download' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items">
          <td>{{'summary_record' | translate}} - {{$store.getters.user.company}}</td>
          <td>{{item.date_range_from}} - {{item.date_range_to}}</td>
          <td><a class="btn btn-success btn-sm" :href="item.summary_path" target="_blank"><i class="fa fa-cloud-download mr-5"></i>Download CSV</a></td>
        </tr>
        </tbody>
      </template>
    </table>
  </div>
  <div v-else>
    <div class="callout callout-info">
      <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
      <p>Es sind keine Labels vorhanden</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items', 'type'],
  data () {
    return {
      sort: 'desc'
    }
  },
  methods: {
    getStore (id) {
      let a = this.$store.getters.storeById(id)
      return `${a.store_number} - ${a.name} - ${a.street} - ${a.street_no} - ${a.zip_code} ${a.city} , ${a.country}`
    }
  },
  mounted () {
  },
  watch: {
    model () {
      this.items = []
    },
    language () {
    },
    type () {}
  }
}
</script>
<style>
  .is-clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/ShipcloudTable.vue